import { createSlice } from "@reduxjs/toolkit";

const STORAGE_KEY = "selectedBusiness";

function loadPersistedBusiness() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

const persisted = loadPersistedBusiness();

export const selectionsSlice = createSlice({
    name: "selections",
    initialState: persisted ? { value: { business: persisted } } : { value: { business: undefined } },
    reducers: {
        selectBusiness: (state: any, action: any) => {
            state.value = { business: action.payload };
            try {
                if (action.payload) localStorage.setItem(STORAGE_KEY, JSON.stringify(action.payload));
                else localStorage.removeItem(STORAGE_KEY);
            } catch {}
        }
    }
});

export const { selectBusiness } = selectionsSlice.actions;
export default selectionsSlice.reducer;
